import { createContext } from 'utils/create-context';

import { CartState } from './types';

const initialState: CartState = {
  debug: false,
};

const [CartProvider, useCartState] = createContext('Cart', initialState);

export { CartProvider, useCartState };
